module.exports = __webpack_public_path__ + "img/1.938fe5f9.jpg";